export type MutationStopDraft = {
  uid: string;
  id?: number | null;
  type: 'loading' | 'unloading';
  position: number;
  pointType?: string | null;
  pointId?: number | null;
  parentLoadingStopId?: number | null;
  address?: string | null;
  city?: string | null;
  contactPerson?: string | null;
  phone?: string | null;
  plannedAt?: string | null;
  actualAt?: string | null;
  notes?: string | null;
  status?: string | null;
};

export type LiveTopologyContract = {
  allowed: boolean;
  forbidden: boolean;
  requiresConfirmation: boolean;
  recalculationRequired: boolean;
  systemStatus?: string;
  policyTier: string;
  reasonCodes: string[];
  affectedSubsystems: string[];
};

export type MutationPolicyPreview = {
  status: 'allowed' | 'confirmation_required' | 'forbidden';
  title: string;
  message: string | null;
  affectedSubsystems: string[];
  requiresConfirmation: boolean;
};

export const MUTATION_REASON_OPTIONS = [
  { value: 'client_request', label: 'Требование клиента' },
  { value: 'address_change', label: 'Изменение адреса' },
  { value: 'delivery_window_change', label: 'Изменение окна доставки' },
  { value: 'additional_load', label: 'Догруз' },
  { value: 'recipient_refusal', label: 'Отказ получателя' },
  { value: 'destination_change', label: 'Изменение назначения' },
  { value: 'other', label: 'Другое' }
] as const;

export const SUBSYSTEM_LABELS: Record<string, string> = {
  projection: 'Execution',
  execution_graph: 'Execution graph',
  coordination: 'Coordination',
  occupancy: 'Occupancy',
  timeline: 'Timeline'
};
